import styled from "styled-components";
import { tokens } from "../../public/tokens";

/**
 * Full-width vertical flex stack, used to lay out stacked page sections.
 * Shared by ProgramDetail.js and programDetail.styles.js, which previously
 * each redefined this same shape under several different names.
 * @param {string} [$gap] - Gap between children. Defaults to spacing-6 (24px).
 */
const FlexColumn = styled.div(({ $gap }) => ({
    display: "flex",
    flexDirection: "column",
    gap: $gap || tokens.globals["spacing-6"],
    width: "100%",
}));

export default FlexColumn;
